export const ERROR_MESSAGES = {
  NO_NETWORK: 'Ingen internetforbindelse. Tjek din forbindelse og prøv igen.'
};

export default ERROR_MESSAGES;
